import React from "react";
import { useTranslation } from "react-i18next";

import Layout from "../../Layout";
import NewsCard from "../NewsCard";
import { news } from "../../../../content/news";

import style from "./styles.module.scss";

const keyI18n = "translations.news";
const SIDEBAR_ITEMS = 5;

interface ArticleLayoutProps {
  children: React.ReactNode;
  lead?: string;
  slug: string;
}

export default function ArticleLayout({ children, lead, slug }: ArticleLayoutProps) {
  const { t } = useTranslation();
  const item = news.find((entry) => entry.slug === slug);

  if (!item) {
    return null;
  }

  const others = news.filter((entry) => entry.slug !== slug).slice(0, SIDEBAR_ITEMS);

  return (
    <Layout title={item.title}>
      <div className={style.body}>
        <article className={style.main}>
          <header className={style.header}>
            <h1 className={`pgm-headline-small ${style.title}`}>{item.title}</h1>
            {lead && <p className={`pgm-body-large ${style.lead}`}>{lead}</p>}
            <p className={`pgm-label-medium ${style.meta}`}>{item.date}</p>
          </header>

          <img
            alt=""
            aria-hidden="true"
            className={style.image}
            decoding="async"
            src={item.image}
          />

          <div className={`pgm-body-large ${style.content}`}>{children}</div>
        </article>

        <aside className={style.aside}>
          <div className={style.asideHeader}>
            <h2 className={`pgm-label-large ${style.asideTitle}`}>
              {t(`${keyI18n}.latest`)}
            </h2>
          </div>

          <div className={style.asideList}>
            {others.map((entry) => (
              <NewsCard item={entry} key={entry.slug} size="small" />
            ))}
          </div>
        </aside>
      </div>
    </Layout>
  );
}
